function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.regexp.exec.js";
import { APPLICATION_FILTER_KEYS } from "../consts";
import jsonApiFilter from "../../../util/jsonApiFilter";
import { API_ROOT } from "../../../constants/consts";
var getBaseApplicationsRequesetUrl = function getBaseApplicationsRequesetUrl(_ref) {
  var paginationAttributes = _ref.paginationAttributes,
    _ref$extraPath = _ref.extraPath,
    extraPath = _ref$extraPath === void 0 ? '' : _ref$extraPath,
    filters = _ref.filters;
  var filterParams = '';
  Object.keys(APPLICATION_FILTER_KEYS).forEach(function (key) {
    var filterKeys = APPLICATION_FILTER_KEYS[key];
    if (key === 'valueFilters') {
      filterKeys.forEach(function (filterKey) {
        filterParams += jsonApiFilter(filterKey, filters[filterKey]);
      });
    } else if (key === 'rangeFilters') {
      filterKeys.forEach(function (filterKey) {
        filterParams += jsonApiFilter(filterKey, filters[filterKey].from, 'from');
        filterParams += jsonApiFilter(filterKey, filters[filterKey].to, 'to');
      });
    }
  });
  var params = [];
  if (paginationAttributes) {
    params.push("page[size]=".concat(paginationAttributes.pageSize), "page[number]=".concat(paginationAttributes.pageNumber));
  }
  if (filterParams) {
    params.push(filterParams);
  }
  return "".concat(API_ROOT, "/api/v2/applications").concat(extraPath, "?").concat(params.join('&'));
};
var getApplicationsRequestUrl = function getApplicationsRequestUrl(_ref2) {
  var paginationAttributes = _ref2.paginationAttributes,
    filters = _ref2.filters,
    isAdmin = _ref2.isAdmin;
  var baseUrl = getBaseApplicationsRequesetUrl({
    paginationAttributes: paginationAttributes,
    filters: filters
  });
  var commonIncludes = ['user.personal_information.address', 'user.agent.agent_information.agent_manager', 'user.agent.agent_information.agent_manager.user', 'program.school', 'original_sales_representative_agent.user', 'user.student_information.sales_representative.user', 'order_item.order.payments', 'current_stage'];
  var adminOnlyIncludes = ['application_service_fee_charges', 'application_service_fee_charges.order_item', 'application_service_fee_charges.application_service_fee'];
  var includes = [].concat(commonIncludes, _toConsumableArray(isAdmin ? adminOnlyIncludes : []));
  return "".concat(baseUrl, "&include=").concat(includes.join(','), "&sort=-id\n");
};
var getApplicationsCountUrl = function getApplicationsCountUrl(filters) {
  var baseUrl = getBaseApplicationsRequesetUrl({
    filters: filters,
    extraPath: '/total_count'
  });
  return baseUrl;
};
export { getApplicationsRequestUrl, getApplicationsCountUrl };